function getTokenFromCookie(tokenName) {
  const data = decodeURIComponent(getCookie(tokenName));
  return data == "undefined" || data == "null" ? null : data;
}

function getCookie(cName) {
  const cookieData = document.cookie.match("(^|;) ?" + cName + "=([^;]*)(;|$)");
  return cookieData ? cookieData[2] : null;
}

export { getTokenFromCookie, getCookie };
